<template>
  <div class="fill-height">
    <section :id="this.$route.params.uuid" class="fill-height"/>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'

import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'

export default {
  name: 'PowerBiDashboard',

  mounted () {
    ApiService.get(`power-bi/cards/${this.$route.params.uuid}`)
      .then((response) => {
        const data = response.data

        console.log(data)

        this.$store.dispatch(SET_BREADCRUMB, [
          { title: 'Power BI' },
          { title: data.title, route: `/power-bi/${this.$route.params.uuid}` },
        ])

        const permissions = pbi.models.Permissions.All

        const config = {
          type: 'dashboard',
          tokenType: pbi.models.TokenType.Embed,
          accessToken: data.token,
          embedUrl: `https://app.powerbi.com/view?r=${data.token}`,
          id: this.$route.params.uuid,
          pageView: 'fitToWidth',
          permissions: permissions,
        }

        const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)

        const dashboardContainer = document.getElementById(this.$route.params.uuid)
        const dashboard = powerbi.embed(dashboardContainer, config)

        dashboard.off('loaded')
        dashboard.off('rendered')

        dashboard.on('error', function () {
          dashboard.off('error')
        })
      })
      .catch((error) => {
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: 'Power BI', route: `/power-bi/${this.$route.params.uuid}` },
          { title: 'Power BI' },
        ])

        console.error('Error fetching dashboard data:', error)
      })
  },
}
</script>
